import { render, staticRenderFns } from "./expert-view.vue?vue&type=template&id=7ff74a7b&scoped=true&"
import script from "./expert-view.vue?vue&type=script&lang=ts&"
export * from "./expert-view.vue?vue&type=script&lang=ts&"
import style0 from "./expert-view.vue?vue&type=style&index=0&id=7ff74a7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff74a7b",
  null
  
)

export default component.exports